export default __webpack_public_path__ + "static/media/GooglePlayStore.12443f6d.svg";